import React from "react";
import "./style.css";
import Stripe from "../../../../../../../../components/Stripe";
import {PAYMENT_TYPE_STRIPE} from "../../../../../../../../const/Pay";

import { Image } from "../../../../../../../../components/Image";
export const PaymentFastMethods = ({
    display,
    setDisplay,
    price,
    walletPaymentTypes = { applePay: false, googlePay: false },
    ...props
                            }) => {
  return (
    <div className="payment-methods" style={{display: display === 0 ? "none" : ""}}>
      <div className="paypal-info">
        <div className="div" onClick={() => {setDisplay(0)}}>
          <div className="credit-card-details">
            <Image src="/static/image/questionnaire/fasting/paymentFastMethods/credit-card-icon.png" alt="Credit card icon" className="img-2" />

            <div className="text-wrapper">Fast payments</div>
          </div>

          <div className="credit-card-logos">
            <Image src="/static/image/questionnaire/fasting/paymentFastMethods/payment-icons.png" alt="Payment icons" className="payment-icons-2" />

            {(walletPaymentTypes.applePay) && (
              <Image src="/static/image/questionnaire/fasting/paymentFastMethods/payment-icons-1.png" alt="Payment icons" className="payment-icons-3" />
            )}
          </div>
        </div>
      </div>

      <div className="credit-card-info">
        <div className="paypal-option">
          <Image src="/static/image/questionnaire/fasting/paymentFastMethods/paypal-icon.png" alt="Paypal icon" className="img-2" />

          <div className="paypal-text">
            <div className="text-wrapper">Credit card</div>
          </div>
        </div>
        <Stripe
            price={price}
            paymentType={PAYMENT_TYPE_STRIPE}
            {

                ...props
            }
        />
      </div>
    </div>
  );
};
